/**
 * Client-side image validation for issue-report attachments. Mirrors the server limits in
 * AryanOnM.Application/Services/IssueReportService (MIME allow-list, 8 MiB/image, ≤10 images).
 * The backend re-validates (incl. magic-byte sniff) regardless — this is for fast inline feedback.
 */

export const ALLOWED_IMAGE_MIMES = ['image/png', 'image/jpeg', 'image/webp', 'image/gif'] as const;

export const MAX_IMAGE_BYTES = 8 * 1024 * 1024; // 8 MiB — matches server per-image cap
export const MAX_IMAGES = 10; // matches server MaxImagesPerReport

/** Returns a user-facing error message, or null when the file is acceptable. */
export function validateImageFile(file: File): string | null {
  if (!(ALLOWED_IMAGE_MIMES as readonly string[]).includes(file.type)) {
    return `Unsupported image type '${file.type || 'unknown'}'. Allowed: PNG, JPEG, WEBP, GIF.`;
  }
  if (file.size > MAX_IMAGE_BYTES) {
    return `'${file.name}' exceeds the 8 MB per-image limit.`;
  }
  return null;
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${String(n)} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(2)} MB`;
}
